<template>
  <v-card>
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">Productores</div>
      <div>
        <v-tabs v-model="currentTab">
          <v-tab :disabled="editMode === 'edit' || editMode === 'new'">
            Lista
          </v-tab>
          <v-tab :disabled="!currentItem">Detalle</v-tab>
        </v-tabs>
      </div>
      <div v-show="currentTab === 1">
        <v-btn color="warning" outlined @click="cancel" class="mx-2">
          Cancelar
        </v-btn>
        <v-btn
          v-show="editMode === 'show'"
          color="success"
          outlined
          @click="edit"
          class="mx-2"
        >
          Editar
        </v-btn>
        <v-btn
          v-show="editMode !== 'show'"
          color="success"
          outlined
          @click="save"
          clss="mx-2"
        >
          Guardar
        </v-btn>
      </div>
    </v-card>

    <v-card-text v-if="currentTab === 0">
      <paginated-search-table
        :endpoint="
          $bRoot.auth.current_level > 2
            ? '/data/producers_hierarchy'
            : '/data/producers'
        "
        ordering="person__name"
        searchLabel="Nombre/CUIT"
        :headers="tableHeaders"
        :canEdit="true"
        :canAdd="true"
        @itemSelected="producerSelected($event, false)"
        @editItem="producerSelected($event, true)"
        @add="addNew"
      ></paginated-search-table>
    </v-card-text>

    <div v-if="currentTab === 1">
      <producer-edit
        :value="
          currentItem
            ? currentItem.url
              ? currentItem.url
              : currentItem.producer
            : null
        "
        :initialmode="editMode"
        :key="currentTab"
        @endEdit="endEdit"
        ref="producerEdit"
      ></producer-edit>
    </div>
  </v-card>
</template>
<script>
import PaginatedSearchTable from "@/components/PaginatedSearchTable.vue";
import ProducerEdit from "@/components/ProducerEdit.vue";

export default {
  name: "Producer",

  components: {
    PaginatedSearchTable,
    ProducerEdit
  },

  data: () => ({
    currentTab: 0,
    currentItem: null,
    editMode: null,
    tableHeaders: [
      { text: "Nombre", value: "name", sortable: false },
      { text: "CUIT", value: "identification", sortable: false },
      { text: "Tipo", value: "category_description", sortable: false },
      { text: "Acciones", value: "actions", sortable: false }
    ]
  }),

  methods: {
    producerSelected(args, edit) {
      this.editMode = edit ? "edit" : "show";
      this.currentItem = args;
      this.currentTab = 1;
    },

    addNew() {
      this.currentItem = null;
      this.editMode = "new";
      this.currentTab = 1;
    },

    async cancel() {
      // eslint-disable-next-line
      if(this.editMode === 'show' || await this.$confirm("Confirme que desea abandonar la edición, los datos modificados se perderán")) {
        this.endEdit();
      }
    },

    save() {
      this.$refs.producerEdit.save();
    },

    edit() {
      if (this.currentItem && this.currentTab === 1) {
        this.editMode = "edit";
        this.$refs.producerEdit.mode = "edit";
        this.$refs.producerEdit.editing = true;
      }
    },

    endEdit() {
      this.editMode = null;
      this.currentItem = null;
      this.error = null;
      this.currentTab = 0;
    }
  },

  mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.remove("home");

    this.$bRoot.errors = null;
  }
};
</script>
